import getDesignTokens from '@vizia/design-tokens';
import Snow from 'dom-snow';
import store from './redux/store';
import MobileDetect from 'mobile-detect/mobile-detect.js';

const handleEffects = (effects) => {
  effects.forEach(effect => {
    switch (effect.type) {
    case 'snow':
      const detect = new MobileDetect(window.navigator.userAgent);
      if (detect.mobile() !== null) {
        //dont render snow on mobile devices
        return;
      }

      const snow = new Snow({
        el: document.body,
        generationSpeed: Math.floor(((effect.speed || 30) / 2000) * window.innerWidth),
        flakeSize: () => Math.random() * (effect.size || 3),
        staticOnceLanded: true,
        flakeCompaction: effect.compaction || 0.9,
        flakesLand: effect.land || 0.9,
        flakeLife: 20000
      });
      window.addEventListener('resize', () => {
        snow.generationSpeed = Math.floor(((effect.speed || 30) / 2000) * window.innerWidth);
        snow.setCollidableDomElements(document.querySelectorAll('.ViziaComponent__card'));
        snow.resize();
      });
      snow.start();

      const updateView = () => {
        snow.setCollidableDomElements(document.querySelectorAll('.ViziaComponent__card'));
        snow.clear(true);
      };

      let slideIndex = store.getState().slides.slideIndex;
      store.subscribe(() => {
        const si = store.getState().slides.slideIndex;
        if (si !== slideIndex) {
          slideIndex = si;
          updateView();
          setTimeout(updateView, 500);
        }
      });
      setTimeout(updateView, 500);

      break;
    default:
      // eslint-disable-next-line no-console
      console.error('no known effect:', effect.type);
    }
  });
};

const createLoadThemeError = () => new Error('Theme could not be loaded');

const loadThemeProps = (theme) => new Promise((resolve) => {
  const {css: cssTokens} = getDesignTokens(theme);

  Object.entries(cssTokens).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });

  requestAnimationFrame(resolve);
});

const loadLegacyTheme = (themeId) => new Promise((resolve, reject) => {
  const url = new URL(`/${themeId}/theme.next.css`, window.env.THEMES_URL).href;
  const link = document.createElement('link');

  link.addEventListener('load', () => {
    requestAnimationFrame(resolve);
  }, { once: true });
  link.addEventListener('error', () => reject(createLoadThemeError()));

  link.href = url;
  link.type = 'text/css';
  link.rel = 'stylesheet';

  document.head.appendChild(link);
});

const loadTheme = (props) => {
  const {theme, themeId} = props;

  if (theme && Object.keys(theme).length) {
    if (theme.effects) {
      handleEffects(theme.effects);
    }
    return loadThemeProps(theme);
  } else if (themeId) {
    console.info('Loading legacy theme'); // eslint-disable-line no-console
    return loadLegacyTheme(themeId);
  }
  return Promise.reject(createLoadThemeError());
};

export default loadTheme;
